var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c(
            "Loading",
            {
              attrs: {
                visible: _vm.loading,
                message: "Caricamento ordine...",
                templateType: _vm.loadTemplateCorrente,
              },
            },
            [
              _c(
                "div",
                [
                  _vm.ordine && _vm.ordine != null
                    ? _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs10: "", "offset-xs1": "" } },
                            [
                              _c(
                                "v-card",
                                [
                                  _c("v-progress-linear", {
                                    staticStyle: { margin: "0" },
                                    attrs: {
                                      color:
                                        _vm.ordine.progresso < 100
                                          ? "info"
                                          : "success",
                                      height: "5",
                                      value: _vm.ordine.progresso,
                                    },
                                  }),
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs8: "" } },
                                            [
                                              _c(
                                                "h3",
                                                {
                                                  staticClass: "headline mb-0",
                                                },
                                                [
                                                  _vm._v("ORDINE NR: "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.ordine.ordineNumero
                                                      ) +
                                                        " / " +
                                                        _vm._s(
                                                          _vm.ordine.ordineLinea
                                                        )
                                                    ),
                                                  ]),
                                                  _vm._v(" DEL "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatDate")(
                                                          _vm.ordine.dataOrdine
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c("div", [
                                                _vm._v("DATA SCADENZA: "),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("formatDate")(
                                                        _vm.ordine.dataScadenza
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]),
                                              _c("div", [
                                                _vm._v("STATO: "),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.ordine.statoAs400
                                                    )
                                                  ),
                                                ]),
                                              ]),
                                              _c("div", [
                                                _vm._v("STAGIONE: "),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.ordine
                                                        .stagioneDecodificata.id
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.ordine
                                                          .stagioneDecodificata
                                                          .descrizione
                                                      )
                                                  ),
                                                ]),
                                              ]),
                                              _c("div", [
                                                _vm._v(" MODELLO: "),
                                                _vm.listaModelliCorrentiSchede
                                                  .length > 0
                                                  ? _c("strong", [
                                                      _c(
                                                        "a",
                                                        {
                                                          on: {
                                                            click:
                                                              _vm.openSchedaTecnicaDialog,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.ordine
                                                                .modelloDecodificato
                                                                .codiceParte
                                                            ) +
                                                              " - " +
                                                              _vm._s(
                                                                _vm.ordine
                                                                  .modelloDecodificato
                                                                  .descrizione
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ])
                                                  : _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.ordine
                                                            .modelloDecodificato
                                                            .codiceParte
                                                        ) +
                                                          " - " +
                                                          _vm._s(
                                                            _vm.ordine
                                                              .modelloDecodificato
                                                              .descrizione
                                                          )
                                                      ),
                                                    ]),
                                              ]),
                                              _c(
                                                "v-dialog",
                                                {
                                                  attrs: { width: "500" },
                                                  model: {
                                                    value:
                                                      _vm.schedaTecnicaDialog,
                                                    callback: function ($$v) {
                                                      _vm.schedaTecnicaDialog =
                                                        $$v
                                                    },
                                                    expression:
                                                      "schedaTecnicaDialog",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-card",
                                                    [
                                                      _c(
                                                        "v-card-title",
                                                        {
                                                          staticClass:
                                                            "headline d-flex justify-space-between",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Scarica scheda tecnica "
                                                          ),
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.schedaTecnicaDialog = false
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-close"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-card-text",
                                                        [
                                                          _vm.isSchedaTecnicaDownloading
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "d-flex justify-center",
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-progress-circular",
                                                                    {
                                                                      attrs: {
                                                                        size: 50,
                                                                        color:
                                                                          "primary",
                                                                        indeterminate:
                                                                          "",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _c(
                                                                "v-row",
                                                                {
                                                                  staticClass:
                                                                    "justify-space-around flex-column align-center",
                                                                  staticStyle: {
                                                                    gap: "15px",
                                                                  },
                                                                },
                                                                [
                                                                  _vm
                                                                    .listaModelliCorrentiSchede
                                                                    .length > 0
                                                                    ? _c(
                                                                        "v-select",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              width:
                                                                                "100%",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              filled:
                                                                                "",
                                                                              items:
                                                                                _vm.listaModelliCorrentiSchede,
                                                                              label:
                                                                                "Modelli schede tecniche",
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm.selectedModelloScheda,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.selectedModelloScheda =
                                                                                    $$v
                                                                                },
                                                                              expression:
                                                                                "selectedModelloScheda",
                                                                            },
                                                                        }
                                                                      )
                                                                    : _vm._e(),
                                                                  _c(
                                                                    "v-btn",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          width:
                                                                            "252px",
                                                                        },
                                                                      attrs: {
                                                                        disabled:
                                                                          !_vm.selectedModelloScheda,
                                                                        color:
                                                                          "primary",
                                                                        size: "x-large",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.downloadSchedaTecnica()
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Scarica"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm.ordine
                                                .lineaVenditaDecodificata
                                                ? _c("div", [
                                                    _vm._v(
                                                      "LINEA DI VENDITA: "
                                                    ),
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.ordine
                                                            .lineaVenditaDecodificata
                                                            .id
                                                        ) +
                                                          " - " +
                                                          _vm._s(
                                                            _vm.ordine
                                                              .lineaVenditaDecodificata
                                                              .descrizione
                                                          )
                                                      ),
                                                    ]),
                                                  ])
                                                : _vm._e(),
                                              _c("div", [
                                                _vm._v("FASE: "),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.ordine
                                                        .faseDecodificata &&
                                                        `${_vm.ordine.faseDecodificata.id} ${_vm.ordine.faseDecodificata.descrizione}`
                                                    )
                                                  ),
                                                ]),
                                              ]),
                                              _c("div", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.ordine.campionario
                                                      ? "CAMPIONARIO"
                                                      : "PRODUZIONE"
                                                  )
                                                ),
                                                _vm.ordine.firstCost == "S"
                                                  ? _c("span", [
                                                      _c("strong", [
                                                        _vm._v(" USA"),
                                                      ]),
                                                    ])
                                                  : _vm._e(),
                                              ]),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "margin-top": "10px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticStyle: {
                                                        width: "200px",
                                                      },
                                                      attrs: {
                                                        color: "primary",
                                                        loading:
                                                          _vm.buttonDownloadIsLoading(),
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.downloadAllegato(
                                                            _vm.ordine.id
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Scarica allegato "
                                                      ),
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: { right: "" },
                                                        },
                                                        [_vm._v("mdi-download")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticStyle: {
                                                        width: "280px",
                                                        "margin-left": "10px",
                                                      },
                                                      attrs: {
                                                        color: "primary",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.showPackingList(
                                                            _vm.ordine.id
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Ordini Avanzamento Fasi "
                                                      ),
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: { right: "" },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-format-list-bulleted"
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "margin-top": "10px",
                                                        "margin-bottom": "10px",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          staticStyle: {
                                                            "margin-right":
                                                              "10px",
                                                            width: "260px",
                                                          },
                                                          attrs: {
                                                            color: "secondary",
                                                            disabled:
                                                              !_vm.canPrintEtichette ||
                                                              !_vm.stampaEtichetteRfidDisponibile,
                                                            size: "x-large",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.stampaEtichettePerOrdine(
                                                                "PRINT_RFID"
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Stampa Etichetta RFID"
                                                          ),
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                right: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-barcode-scan"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          staticStyle: {
                                                            "margin-right":
                                                              "10px",
                                                            width: "260px",
                                                          },
                                                          attrs: {
                                                            color: "secondary",
                                                            disabled:
                                                              !_vm.canPrintEtichette ||
                                                              !_vm.stampaEtichetteNoRfidDisponibile,
                                                            size: "x-large",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.stampaEtichettePerOrdine(
                                                                "PRINT_NORFID"
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Stampa Etichetta NO-RFID"
                                                          ),
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                right: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-barcode"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _vm.canResetEPC
                                                        ? _c(
                                                            "v-btn",
                                                            {
                                                              staticStyle: {
                                                                width: "130px",
                                                              },
                                                              attrs: {
                                                                color:
                                                                  "secondary",
                                                                disabled:
                                                                  !_vm.canPrintEtichette ||
                                                                  !_vm.stampaEtichetteRfidDisponibile,
                                                                size: "x-large",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.stampaEtichettePerOrdine(
                                                                      "RESET_EPC"
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Reset EPC"
                                                              ),
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    right: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-barcode-off"
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            loading:
                                                              _vm.xlsxPackingListOrdineLoading,
                                                            color:
                                                              "blue lighten-2",
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.downloadXLSXPackingListOrdine,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Scarica XLSX Packing List Ordine "
                                                          ),
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                right: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-download"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "margin-top": "10px",
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(" NOTE "),
                                                  ]),
                                                  _vm.ordine.note &&
                                                  _vm.ordine.note.length > 0 &&
                                                  !_vm.inModificaNote
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            border:
                                                              "1px solid gainsboro",
                                                            background:
                                                              "lightyellow",
                                                            padding: "5px",
                                                            "margin-left":
                                                              "5px",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.ordine.note
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm.inModificaNote
                                                    ? _c(
                                                        "span",
                                                        [
                                                          _c("v-textarea", {
                                                            attrs: {
                                                              autofocus: "",
                                                              hint: "Note ordine",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.valoreNoteTemp,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.valoreNoteTemp =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "valoreNoteTemp",
                                                            },
                                                          }),
                                                          _c(
                                                            "v-card-actions",
                                                            [
                                                              _c("v-spacer"),
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "darken-1",
                                                                    text: "",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        _vm.inModificaNote = false
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Annulla"
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "green darken-1",
                                                                    text: "",
                                                                    loading:
                                                                      _vm.loading,
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      _vm.inviaModificaNote,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Salva"
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  !_vm.inModificaNote
                                                    ? _c(
                                                        "span",
                                                        [
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              attrs: {
                                                                icon: "",
                                                                ripple: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.modificaNote,
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    small: "",
                                                                    color:
                                                                      "grey lighten-1",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-pencil"
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c("v-flex", { attrs: { xs4: "" } }, [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "text-align": "right",
                                                },
                                              },
                                              [
                                                _c(
                                                  "h2",
                                                  {
                                                    staticStyle: {
                                                      float: "right",
                                                      margin: "0 10px 20px 0",
                                                      "item-aligns": "center",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticStyle: {
                                                          "vertical-align":
                                                            "middle",
                                                        },
                                                        attrs: {
                                                          large: "",
                                                          color:
                                                            "blue darken-2",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "statoOrdineIco"
                                                              )(
                                                                _vm.ordine.stato
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _c("span", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.ordine.stato
                                                          ) +
                                                          " "
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        staticStyle: {
                                                          width: "200px",
                                                        },
                                                        attrs: {
                                                          color: "primary",
                                                          disabled:
                                                            !_vm.progressiGestibili,
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.editProgressi,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(" Progresso "),
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              right: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-check-all"
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "margin-top": "10px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        staticStyle: {
                                                          width: "200px",
                                                        },
                                                        attrs: {
                                                          color: "primary",
                                                          disabled:
                                                            !_vm.azioniDisponibili,
                                                        },
                                                        on: {
                                                          click: _vm.menuAzioni,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(" Azioni "),
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              right: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-cloud-upload"
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _vm.statoLavorazioniAllineato
                                            ? _c(
                                                "div",
                                                [
                                                  _c("StatoWorkflow", {
                                                    attrs: {
                                                      stato:
                                                        _vm.ordine
                                                          .lavorazioni[0].stato,
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-dialog",
                                    {
                                      attrs: { persistent: "" },
                                      model: {
                                        value: _vm.dialog,
                                        callback: function ($$v) {
                                          _vm.dialog = $$v
                                        },
                                        expression: "dialog",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-card",
                                        [
                                          _c(
                                            "v-card-title",
                                            { staticClass: "headline" },
                                            [
                                              _vm._v(
                                                "Avanzamento progresso per ordine"
                                              ),
                                            ]
                                          ),
                                          _c("ProgressoOrdine", {
                                            on: {
                                              "on-completed": function (
                                                $event
                                              ) {
                                                _vm.dialog = false
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.ordine.datiAggiuntivi &&
                          _vm.ordine.datiAggiuntivi.length > 0
                            ? _c(
                                "v-flex",
                                { attrs: { xs10: "", "offset-xs1": "" } },
                                [
                                  _c("v-card-title", [
                                    _c("h2", [_vm._v("Dati aggiuntivi")]),
                                  ]),
                                  _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticStyle: {
                                            color: "white",
                                            "margin-top": "15px",
                                            "margin-left": "24px",
                                            "margin-bottom": "5px",
                                          },
                                          attrs: { color: "green lighten-2" },
                                          on: { click: _vm.saveDatiAggiuntivi },
                                        },
                                        [
                                          _vm._v(" Salva dati "),
                                          _c(
                                            "v-icon",
                                            { attrs: { right: "" } },
                                            [_vm._v("mdi-content-save-outline")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-container",
                                        {
                                          attrs: {
                                            fluid: "",
                                            "grid-list-md": "",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            _vm._l(
                                              _vm.ordine.datiAggiuntivi,
                                              function (m, i) {
                                                return _c(
                                                  "v-flex",
                                                  {
                                                    key: m.name,
                                                    attrs: {
                                                      xs12: "",
                                                      sm6: "",
                                                      md4: "",
                                                    },
                                                  },
                                                  [
                                                    _c("CardEntityMetadata", {
                                                      attrs: {
                                                        entityMetadata: m,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-flex",
                            { attrs: { xs10: "", "offset-xs1": "" } },
                            [
                              _c("v-card-title", [
                                _c("h2", [_vm._v("Righe consegna")]),
                              ]),
                              _c(
                                "v-card",
                                [
                                  _c("LavorazioniList", {
                                    attrs: {
                                      "data-test": "lista-lavorazioni",
                                      lavorazioni: _vm.ordine.lavorazioni,
                                      workflow: !_vm.statoLavorazioniAllineato,
                                      compact: true,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c("div", [
                        _vm._v(" OPPPSSS... Nessun dato da visualizzare. "),
                      ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }